import React, { useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ButtonField from 'src/Components/Ui/ButtonField';
import OpenInNewTwoToneIcon from '@mui/icons-material/OpenInNewTwoTone';
import { ENV_DECLARONS, ENV_TEACHR, ENV_VERIFIED_TRAINER, getActiveAppBrandConfig, getActiveBrandConfig, getActiveClientBrandConfig, getActivePrestationBrandConfig, isBrandActive } from '../../../config/environment.config';
import useTailwindBrand from '../../../Theme/useTailwindBrand';
import {  userUnSetCurrentRegister } from '../../../Redux/Actions/UserActions';
// import Teachr_Repository from '../../../Repositories/Teachr_Repository';
// import TeachrRepository from '../../../Repositories/TeachrRepository';
import { useBrandAuthConfig } from '../../../Hooks/Auth/useBrandAuthConfig';
import config from '../../../config/config';
import LayoutSteps from '../LayoutSteps';
// import LayoutSteps from '../LayoutSteps';

interface RegisterLastProps {
  /** Espace client : même écran de félicitations, bouton vers l'espace client. */
  isClient?: boolean;
}

export default function RegisterLast({ isClient = false }: RegisterLastProps) {
  const [loading, setLoading] = useState(false);
  const route = getActiveBrandConfig();
  const { common, classes } = useTailwindBrand();
  const { designConfig: registerDesignConfig } = useBrandAuthConfig();

  const currentUser = useSelector((state: any) => state?.user?.currentUser);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Le prof a indiqué peu d'élèves et souhaité des conseils à l'étape précédente :
  // on lui propose un bouton pour accéder à la page partenaire.
  const showPartnerAdvice = useMemo(
    () => !isClient && sessionStorage.getItem('showPartnerAdvice') === 'true',
    [isClient]
  );

  const goToProfile = useMemo(
    () => () => {
      if (currentUser) {
        sessionStorage.removeItem('showPartnerAdvice');
        dispatch(userUnSetCurrentRegister());
        navigate(`/${route}/tableau-de-bord`)
      }
    },
    [currentUser, dispatch, navigate, route, isClient]
  );

  const goToPartner = () => {
    sessionStorage.removeItem('showPartnerAdvice');
    window.location.href = isBrandActive(ENV_TEACHR) ? config.partnerAdviceUrl : config.partnerAdviceUrlDeclarons;
  };

  // Configuration du design selon la marque
  const lastStepConfig = useMemo(() => {
    if (isClient) {
      // Espace client : mêmes félicitations, prochaines étapes côté client
      return {
        background: '',
        icon: null,
        iconAlt: null,
        title: '🎉 Compte créé avec succès !',
        subtitle:
          <>
            Bienvenue sur la plateforme <strong className={`${classes.primaryText}`}>{getActiveAppBrandConfig()}</strong>  😊.  <br />Votre compte est désormais actif et vous pouvez dès maintenant accéder à votre tableau de bord. <br />
            👉 Ce qui vous attend :<br />
            📅 Suivez vos {getActivePrestationBrandConfig("s")} à venir et votre historique<br />
            📁 Retrouvez vos devis, factures et attestations dans Mes documents<br />
            ⚙️ Gérez vos informations et vos préférences dans Paramètres<br />
          </>,
        buttonClass: 'bg-second text-white py-2 uppercase',
        buttonText: 'Accéder à mon tableau de bord',
      };
    }
    if (isBrandActive(ENV_VERIFIED_TRAINER)) {
      return {
        background:
          'bg-gradient-to-br from-[#0dcebf] via-[#34454e] to-[#8B4513]',
        icon: '/brands/verified-trainer/images/sigle-logo-white.png',
        iconAlt: 'Fitness Icon',
        title: '🎉 Compte créé avec succès !',
        subtitle:
          'Félicitations ! Votre inscription en tant que coach sportif est maintenant terminée. Pour finaliser votre profil et commencer à recevoir des demandes de clients, nous vous invitons à compléter les informations de votre profil professionnel.',
        buttonClass:
          'bg-[#34454e] text-white py-3 px-8 uppercase rounded-lg hover:bg-[#2F4F4F] transition-all duration-300 shadow-lg transform hover:scale-105',
        buttonText: 'Tableau de bord',
      };
    } else if (isBrandActive(ENV_DECLARONS)) {
      return {
        background: '',
        icon: '/brands/declarons/fiveicon.svg',
        iconAlt: 'Declarons Icon',
        title: '🎉 Compte créé avec succès !',
        subtitle:
          <>
            Bienvenue sur la plateforme <strong className={`${classes.primaryText}`}><strong className={`${classes.primaryText}`}>{getActiveAppBrandConfig()}</strong> </strong>  😊.  <br />Votre compte est désormais actif et vous pouvez dès maintenant accéder à votre tableau de bord. <br />
            👉 Prochaines étapes pour bien démarrer :<br />
            🎓 Ajoutez votre premier {getActiveClientBrandConfig()}<br />
            👤 Complétez votre profil afin de finaliser la validation de votre compte<br />
            📚 Commencez à déclarer vos {getActivePrestationBrandConfig("s")} en toute simplicité<br />

            Ces étapes sont essentielles pour vous permettre de profiter pleinement de toutes les fonctionnalités et garantir une expérience fluide et sécurisée.<br />

            {/* ✨ Prenez quelques instants pour compléter les informations nécessaires et lancez-vous ! */}
          </>,
        buttonClass: `bg-[#673AB7] text-white py-3 px-8 uppercase rounded-lg hover:bg-[#4A148C] transition-all duration-300 shadow-lg transform hover:scale-105`,
        buttonText: 'Compléter votre profil',
      };
    } else {
      // Teach'r - design par défaut
      return {
        background:
          'bg-center bg-no-repeat bg-contain overflow-hidden last-step-height md:bg-right-bottom bg-bgRegister md:h-full',
        icon: null,
        iconAlt: null,
        title: '🎉 Compte créé avec succès !',
        subtitle:
          <>
            Bienvenue sur la plateforme <strong className={`${classes.primaryText}`}>{getActiveAppBrandConfig()}</strong>  😊.  <br />Votre compte est désormais actif et vous pouvez dès maintenant accéder à votre tableau de bord. <br />
            👉 Prochaines étapes pour bien démarrer :<br />
            🎓 Ajoutez votre premier {getActiveClientBrandConfig()}<br />
            👤 Complétez votre profil afin de finaliser la validation de votre compte<br />
            📚 Commencez à déclarer vos {getActivePrestationBrandConfig("s")} en toute simplicité<br />

            Ces étapes sont essentielles pour vous permettre de profiter pleinement de toutes les fonctionnalités et garantir une expérience fluide et sécurisée.<br />

            {/* ✨ Prenez quelques instants pour compléter les informations nécessaires et lancez-vous ! */}
          </>
        ,
        steps: null,
        buttonClass: 'bg-second text-white py-2 uppercase',
        buttonText: 'Accéder au tableau de bord',
      };
    }
  }, [isClient, classes.primaryText]);

  return (
    <LayoutSteps
      designConfig={registerDesignConfig}
      loading={loading}
      handleSubmit={goToProfile}
      btnText={lastStepConfig.buttonText}
      stepNumber={3}
      isClient={isClient}
      totalSteps={3}
      children={
        <div className="flex flex-col items-center justify-center text-center py-8" key={3}>
          <div className="flex flex-col gap-y-6 w-full">
            <p
              className={`${common.body} leading-relaxed text-left`}
            >
              {lastStepConfig.subtitle}
            </p>

            {(showPartnerAdvice && !isBrandActive(ENV_VERIFIED_TRAINER)) && (
              <div className="flex flex-col gap-y-3 w-full text-left rounded-lg border border-gray-200 bg-gray-50 p-4">
                <p className={`${common.body} leading-relaxed`}>
                  Vous souhaitiez être accompagné pour développer votre activité :
                  accédez dès maintenant à notre page partenaire dédiée.
                </p>
                
                <ButtonField
                  label={"Accéder à la page partenaire"}
                  variant="outlined"
                  className="font-bold w-full"
                  onClick={goToPartner}
                  disabled={loading}
                  loading={loading}
                  endIcon={<OpenInNewTwoToneIcon />}
                />
     
              </div>
            )}
          </div>
        </div>
      }
    />
  );
}


